export function copyObj(object: any) {
    return JSON.parse(JSON.stringify(object));
}

export function generateGUID() {
    // Generate a random string that follows the typical GUID format: XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
